import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import CONFIG from "@/assets/js/config.custom.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import ValidationService from "@/services/ValidationService";
import {
  integer,
  requiredIf,
  minLength,
  maxLength,
  minValue
} from "vuelidate/lib/validators";

export default {
  name: "adminEdit",
  components: {
    MainLayout,
    Select2Multiple,
    Loading,
  },
  mixins: [ValidationService],
  data() {
    return {
      itemData: [],
      submitted: false,
      isLoading: false,
      disabled: false,
      itemExists: false,
      itemTypeArr: [],
      itemTypeArrFilter: [],
      gradeArr: [],
      acdYearArr: [],
      savedCampusGradeIds: [],
      transactionCategoryArr: [],
      CONFIG,
      defaultSelectOption:  [{
                        'id': 0,
                        'text': 'All'
                      }],
    };
  },

  validations: {
    itemData: {
      p_item_name: {
        required: requiredIf(function () {
          return !this.isProtectedItem;
        }),
        maxLength: maxLength(100)
      },
      p_item_amount: {
        required: requiredIf(function () {
          return !this.isAmountDisabled;
        }),
        integer,
        maxLength: maxLength(9),
        minValue: minValue(0)
      },
      item_type: {
        required: requiredIf(function () {
          return !this.isProtectedItem;
        }),
        integer,
        minValue: minValue(1),
      },
      acd_year_id: {
        required: requiredIf(function () {
          return !this.isProtectedItem;
        }),
        integer: true,
        minValue: 1,
      },
      campus_grade_ids: {
        minLength: minLength(1),
      }
    },
  },

  watch: {
    "itemData.item_type"() {
      this.validationErrors.item_type = [];
    },
    "itemData.campus_grade_ids"() {
      this.validationErrors.campus_grade_ids = [];
    },
    "itemData.acd_year_id"(newVal) {
      this.validationErrors.acd_year_id = [];
      if (this.isLateFee) return;
      this.validationErrors.campus_grade_ids = [];
      this.itemData.campus_grade_ids = [];
      this.gradeArr = [];
      if (newVal) {
        this.getClasses();
      }
    }
  },

  computed: {
    isLateFee() {
      return Number(this.itemData.item_type) === CONFIG.PAYMENT_ITEM_TYPES_Id.lateFee;
    },
    isTuitionFee() {
      return Number(this.itemData.item_type) === CONFIG.PAYMENT_ITEM_TYPES_Id.tuitionFee;
    },
    isFerryFee() {
      return Number(this.itemData.item_type) === CONFIG.PAYMENT_ITEM_TYPES_Id.ferryFee;
    },
    isProtectedItem() {
      return this.isTuitionFee || this.isFerryFee || this.isLateFee;
    },
    isAmountDisabled() {
      return this.isTuitionFee;
    },
    isValidGrades() {
      return this.itemData.campus_grade_ids.every(id => !isNaN(Number(id)));
    },

    isGradesExceedLimit() {
      return this.itemData.campus_grade_ids.join(",").length > 2000;
    }
  },

  methods: {
    async checkDuplicateItem() {
      try {
        const response = await axios.get("/item/checkDuplicateItem", {
          params: {
            id: this.itemData.id,
            item_name: this.itemData.p_item_name,
            acd_year_id: this.itemData.acd_year_id || null,
          },
        });
        this.itemExists = response.data.exists;
        this.submitted = false;
        this.disabled = false;
      } catch (error) {
        console.error('An error occurred:', error);
      }
    },

    getClasses() {
      if (!this.itemData.acd_year_id) {
        this.gradeArr = [];
        return;
      }
      axios.get('campusGrade/list-by-acdYear/', {
        params: {
          campus_id: this.$store.state.user.campus_id,
          acd_year_id: this.itemData.acd_year_id,
          get_grade: true,
        }
      }).then(res => {
        this.gradeArr = [
          { id: 0, text: 'All' },
          ...res.data.map(grade => ({
            id: Number(grade.campus_grade_id),
            text: grade.grade_name,
          })),
        ];
        if (this.savedCampusGradeIds && this.savedCampusGradeIds.length > 0) {
          this.itemData.campus_grade_ids = this.savedCampusGradeIds
            .map(id => Number(id))
            .filter(id => !isNaN(id));
          this.savedCampusGradeIds = [];
        }
      })
        .catch((err) => {
          if (err.response && err.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    getAcademicYear() {
      axios.get("period/periodList")
        .then(res => {
          this.acdYearArr = res.data.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    getTransactionCategories() {
      axios.get(`/transactionCategory/getTransactionCategoryArray?type=${CONFIG.TRANSACTION_TYPE.INCOME}`)
        .then(res => {
          const categoryList = Array.isArray(res.data?.[0]) ? res.data[0] : [];
          this.transactionCategoryArr = [
            { id: 0, text: 'Select Transaction Category' },
            ...categoryList.map((category) => ({
              id: category.id,
              text: category.text ?? category.category_name ?? "",
            }))
          ];
        })
        .catch((error) => {
          if (error.response?.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    getDetail() {
      axios.get(`item/detail/${this.$route.params.id}`, { params: { is_edit: true } })
        .then(res => {
          if (res.data && res.data.data) {
            const data = res.data.data;
            this.itemData = {
              id: data.id,
              p_item_name: data.p_item_name,
              p_item_amount: data.p_item_amount,
              item_type: data.item_type,
              acd_year_id: [CONFIG.PAYMENT_ITEM_TYPES_Id.lateFee, CONFIG.PAYMENT_ITEM_TYPES_Id.ferryFee].includes(Number(data.item_type)) ? null : data.acd_year_id,
              campus_grade_ids: [],
              transaction_category_id: data.transaction_category_id ?? 0,
            };
            this.savedCampusGradeIds = Array.isArray(data.campus_grade_ids)
              ? data.campus_grade_ids.map(id => String(id))
              : [];
            this.itemTypeArr = Object.entries(this.CONFIG.PAYMENT_ITEM_TYPES)
              .map(([id, text]) => ({ id: Number(id), text }));

            const currentItemType = Number(data.item_type);
            const isTypeInList = this.itemTypeArr.some(type => type.id === currentItemType);

            if (!isTypeInList) {
              const typeText = this.CONFIG.ALL_PAYMENT_ITEM_TYPES[currentItemType] ||
                this.CONFIG.PAYMENT_ITEM_TYPES_FILTER[currentItemType] ||
                "Unknown Type";
              this.itemTypeArr.push({ id: currentItemType, text: typeText });
            }
            if (!this.isLateFee && this.itemData.acd_year_id) {
              this.getClasses();
            } else {
              this.isLoading = false;
            }
          }
        })
        .catch(error => {
          if (error.response?.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    async confirmUpdate() {
      if (this.disabled) return;
      this.submitted = this.disabled = true;
      await this.checkDuplicateItem();
      if (this.itemExists) {
        this.$notification.error("Payment Item Name is already exist.", {
          timer: 3,
          position: "bottomCenter"
        });
        return;
      }
      this.update();
    },

    update() {
      this.submitted = true;
      if (this.$v.$invalid || !this.isValidGrades || this.isGradesExceedLimit) {
        this.disabled = false;
        return;
      }
      this.itemData.loginID = this.$store.state.user.id;
      const payload = {
        ...this.itemData,
        transaction_category_id: this.itemData.transaction_category_id && this.itemData.transaction_category_id !== 0
          ? this.itemData.transaction_category_id
          : 0,
      };
      axios.post(`item/update/${this.$route.params.id}`, payload)
        .then(res => {
          if (res.data.success === true) {
            this.$notification.success("Item Updated Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "itemList"
            });
          } else {
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          }
        })
        .catch(error => {
          if (error.response?.status === 422) {
            this.printValidationError(error.response);
          } else {
            this.printValidationError(error.response);
          }
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        })
        .finally(() => {
          this.isLoading = this.disabled = false;
        })
    }
  },

  mounted() {
    this.isLoading = true;
    this.itemTypeArr = Object.entries(this.CONFIG.PAYMENT_ITEM_TYPES)
      .map(([id, text]) => ({ id: Number(id), text }));
    if (!this.isLateFee) {
      this.getClasses();
    }
    this.getAcademicYear();
    this.getTransactionCategories();
    this.getDetail();
  },
};
